import { render, staticRenderFns } from "./dash-settings.vue?vue&type=template&id=08d16cb0&scoped=true"
import script from "./dash-settings.vue?vue&type=script&lang=js"
export * from "./dash-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d16cb0",
  null
  
)

export default component.exports